<template>
    <div class="auth-component">
        <div class="select-form mb-3" v-if="register">
            <div :class="{ active: type === 'login' }" @click="changeShowFormType('login')">Вход</div>
            <div :class="{ active: type === 'register' }" @click="changeShowFormType('register')">
                Регистрация
            </div>
        </div>
        <div v-if="type === 'login'" class="login-form">
            <form method="POST"
                  @submit.prevent="onSubmit(urls['login'])"
                  @keydown="form.errors.clear($event.target.name)">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           name="email"
                           placeholder="E-Mail"
                           v-model="form.email"
                    >
                    <span class="text-danger"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')">
                    </span>
                </div>
                <div class="form-group position-relative">
                    <input :type="showPassword ? 'text' : 'password'"
                           class="form-control"
                           name="password"
                           placeholder="Пароль"
                           v-model="form.password"
                    >
                    <span class="text-danger"
                          v-if="form.errors.has('password')"
                          v-text="form.errors.get('password')">
                    </span>
                    <div class="show-pass" @click="showPass"></div>
                </div>
                <a class="btn-link" title="Забыли пароль?" @click="changeShowFormType('reset')">
                    Забыли пароль?
                </a>
                <div class="form-group">
                    <button type="submit" :disabled="form.errors.any()" class="btn">
                        Войти
                    </button>
                </div>
            </form>
        </div>
        <div v-if="type === 'register' && register" class="register-form">
            <form method="POST"
                  @submit.prevent="onSubmit(urls['register'])"
                  @keydown="form.errors.clear($event.target.name)">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           name="name"
                           placeholder="Имя"
                           v-model="form.name"
                    >
                    <span class="text-danger"
                          v-if="form.errors.has('name')"
                          v-text="form.errors.get('name')">
                    </span>
                </div>
                <div class="form-group">
                    <input type="text"
                           class="form-control email-input-mask"
                           name="email"
                           placeholder="E-Mail"
                           v-model="form.email"
                    >
                    <span class="text-danger"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')">
                    </span>
                </div>
                <div class="form-group position-relative">
                    <input :type="showPassword ? 'text' : 'password'"
                           class="form-control"
                           name="password"
                           placeholder="Пароль"
                           v-model="form.password">
                    <span class="text-danger"
                          v-if="form.errors.has('password')"
                          v-text="form.errors.get('password')">
                    </span>
                    <div class="show-pass" @click="showPass"></div>
                </div>
                <a class="btn-link" title="Забыли пароль?" @click="changeShowFormType('reset')">
                    Забыли пароль?
                </a>
                <div class="form-group">
                    <button type="submit" :disabled="form.errors.any()" class="btn">
                        Регистрация
                    </button>
                </div>
            </form>
        </div>
        <div v-if="type === 'reset'" class="password-reset-form">
            <form method="POST"
                  @submit.prevent="onSubmit(urls['reset'])"
                  @keydown="form.errors.clear($event.target.name)">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           name="email"
                           placeholder="E-Mail"
                           v-model="form.email"
                    >
                    <span class="text-danger"
                          v-if="form.errors.has('email')"
                          v-text="form.errors.get('email')">
                    </span>
                </div>
                <div class="form-group">
                    <button type="submit" :disabled="form.errors.any()" class="btn">
                        Отправить ссылку для сброса пароля
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
  export default {
    name: "AuthComponent",
    data() {
      return {
        form: new Form({
          email: '',
          password: '',
          name: '',
        }),
        register: false,
        showPassword: false,
        type: 'login',
        urls: {
          'login': '/login',
          'reset': '/password/reset',
          'register': '/register',
        },
      }
    },
    methods: {
      onSubmit(url) {
        this.form.submit('post', url).then(res => {
          location.reload();
        }).catch(rej => console.log(rej));
      },
      showPass() {
        this.showPassword = !this.showPassword;
      },
      changeShowFormType(newType) {
        this.type = newType;
        this.form.errors.clear();
      },
    },

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/AuthComponent.vue